import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DialogComponent } from './dialog/dialog.component';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { SafeurlPipe } from './pipes/safeurl.pipe';
import { HttpClientModule } from '@angular/common/http';




@NgModule({
  declarations: [
    DialogComponent,
    SafeurlPipe
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    LazyLoadImageModule
  ],
  exports:[
    FormsModule,
    ReactiveFormsModule,
    LazyLoadImageModule
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class SharedModule { }
